export default __webpack_public_path__ + "static/media/content.bc539dda.svg";